import { PublicKey } from '@solana/web3.js';
import { useQuery } from '@tanstack/react-query';

import { getUserPositionStateAccount } from '@/constants/helpers';
import { program } from '@/constants/solana';
import { compareData } from '@/utils/fetch.utils';

export const useFetchUserPositionState = (
  user: PublicKey | string | null,
  marketId: number,
) => {
  return useQuery({
    queryKey: ['user-position-state', user, marketId],
    refetchInterval: 60 * 1000,
    structuralSharing: compareData,
    queryFn: async () => {
      if (!user) return null;
      return await program.account.userPositionState.fetch(
        getUserPositionStateAccount(new PublicKey(user), marketId),
      );
    },
  });
};
